export const bannerContentArabic = {
    shortHeading: "تطوير تطبيقات الويب",
    mainHeadingGreenText: "خدمات",
    mainHeading: "موثوق به من قبل الشركات الناشئة والشركات الصغيرة والمتوسطة والمؤسسات على حد سواء",
    description: "بصفتنا شركة رائدة في تطوير تطبيقات الويب، تقدم Bitsclan IT Solutions خدمات تطوير تطبيقات ويب من الدرجة الأولى لمساعدتك في تحقيق أهداف عملك. نحن نبني تطبيقات ويب قوية وآمنة وقابلة للتطوير، مما يضمن الموثوقية والتكامل السلس.",
    bannerBtnText: "لنبدأ",
}

export const TypesOfBuildDataArabic = {
    mainHeading: "الميزات الرئيسية لتطبيقات الويب عالية الجودة",
    TypesOfBuildDataAccordian: [
        {
            id: "collapseOne",
            question: "خدمات التطوير",
            answer: {
                discription:
                    "بصفتنا شريكًا متخصصًا في تطوير تطبيقات الويب، نتبع نهجًا يركز على العميل لتقديم حلول مخصصة. من خلال الجمع بين الأطر الحديثة، والمنهجيات الرشيقة، والتفكير المبتكر، نقوم بإنشاء تطبيقات ويب تلبي أهداف عملك الفريدة بدقة وقابلية للتوسع وجودة لا مثيل لها.",
                listTitle: "",
                listContent: [],
            },
        },
        {
            id: "collapseTwo",
            question: "آمنة",
            answer: {
                discription:
                    "تم تصميم تطبيقات الويب الآمنة لدينا لحماية البيانات الحساسة ومنع نقاط الضعف، مما يضمن ثقة المستخدم. باستخدام الاتصال المشفر وبروتوكولات المصادقة القوية، نقدم حلولًا تحمي معلومات عملك وعملائك.",
                listTitle: "تطبيقات الويب الآمنة لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "معالجة بيانات المستخدم أو الأعمال الحساسة",
                    },
                    {
                        line: "المعاملات المالية والتجارة الإلكترونية",
                    },
                    {
                        line: "منع الخروقات الأمنية",
                    },
                    {
                        line: "ضمان الامتثال للوائح",
                    },
                    {
                        line: "بناء الثقة مع المستخدمين النهائيين",
                    },
                ],
            },
        },
        {
            id: "collapseThree",
            question: "سريعة",
            answer: {
                discription:
                    "السرعة تدفع رضا المستخدم، وتطبيقات الويب لدينا مصممة للتحميل بسرعة والأداء بسلاسة. باستخدام التعليمات البرمجية المحسّنة والأطر المتقدمة، ننشئ حلولًا سريعة الاستجابة تحافظ على تفاعل جمهورك.",
                listTitle: "تطبيقات الويب السريعة لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "المنصات ذات حركة المرور العالية",
                    },
                    {
                        line: "متطلبات المعالجة في الوقت الفعلي",
                    },
                    {
                        line: "تحسين تجربة المستخدم",
                    },
                    {
                        line: "تقليل معدلات الارتداد",
                    },
                    {
                        line: "تقديم تحديثات سريعة للبيانات",
                    },
                ],
            },
        },
        {
            id: "fourth",
            question: "قابلة للتوسع",
            answer: {
                discription:
                    "تم تصميم تطبيقات الويب القابلة للتوسع لدينا لتنمو مع عملك. بفضل البنى المرنة والحلول المستندة إلى السحابة، فإنها تتعامل مع زيادة المستخدمين والميزات والبيانات بسهولة، مما يدعم نجاحك.",
                listTitle: "تطبيقات الويب القابلة للتوسع لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "الشركات الناشئة التي تخطط للنمو",
                    },
                    {
                        line: "الشركات ذات أحمال المستخدمين المتقلبة",
                    },
                    {
                        line: "المنصات متعددة الوظائف",
                    },
                    {
                        line: "التعامل مع العمليات واسعة النطاق",
                    },
                    {
                        line: "التطبيقات الجاهزة للمستقبل",
                    },
                ],
            },
        },
        {
            id: "fifth",
            question: "قوية",
            answer: {
                discription:
                    "نصمم تطبيقات ويب موثوقة ومرنة وقادرة على التعامل مع أعباء العمل الثقيلة. تضمن هذه الحلول القوية وظائف خالية من العيوب، حتى في ظل الظروف الصعبة.",
                listTitle: "تطبيقات الويب القوية لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "عمليات الأعمال المعقدة",
                    },
                    {
                        line: "التطبيقات التي تتطلب أداءً عاليًا",
                    },
                    {
                        line: "العمليات كثيفة البيانات",
                    },
                    {
                        line: "حلول على مستوى المؤسسات",
                    },
                    {
                        line: "المتانة على المدى الطويل",
                    },
                ],
            },
        },
        {
            id: "Sixth",
            question: "متجاوبة",
            answer: {
                discription:
                    "ننشئ تطبيقات ويب تتكيف بشكل جميل مع أي جهاز، مما يوفر تجربة متسقة وممتعة للمستخدمين على أجهزة الكمبيوتر المكتبية والأجهزة اللوحية والهواتف المحمولة.",
                listTitle: "تطبيقات الويب المتجاوبة لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "إمكانية الوصول عبر أجهزة متعددة",
                    },
                    {
                        line: "الاتساق عبر الأنظمة الأساسية",
                    },
                    {
                        line: "تعزيز مشاركة المستخدم",
                    },
                    {
                        line: "الشركات التي تركز على الجوّال أولاً",
                    },
                    {
                        line: "الوصول إلى جماهير أوسع",
                    },
                ],
            },
        },
        {
            id: "seventh",
            question: "سهلة الاستخدام",
            answer: {
                discription:
                    "تطبيقات الويب سهلة الاستخدام لدينا بديهية وبسيطة، مما يجعل التنقل سهلاً. مصممة مع وضع المستخدم النهائي في الاعتبار، فإنها تعزز المشاركة وتضمن الرضا في كل خطوة.",
                listTitle: "تطبيقات الويب سهلة الاستخدام لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "تبسيط المهام المعقدة",
                    },
                    {
                        line: "تحسين الاحتفاظ بالمستخدمين",
                    },
                    {
                        line: "خلق تجارب ممتعة",
                    },
                    {
                        line: "تلبية احتياجات المستخدمين غير التقنيين",
                    },
                    {
                        line: "تعزيز ولاء العلامة التجارية",
                    },
                ],
            },
        },
    ]
}

export const WhoWeServeDataArabic = {
    WhoWeServeSectionContent: {
        mainHeading: "من نخدم",
        sectionDescription: "من خلال خدماتنا المتقدمة لتطوير تطبيقات الويب، نمكّن الشركات من تسخير أحدث التقنيات. سواء كان الأمر يتعلق بالذكاء الاصطناعي، أو إنترنت الأشياء، أو البلوك تشين، فإننا نبني حلولًا تحوّل الأفكار إلى حقائق مؤثرة. بغض النظر عن مجال عملك، فإننا نقدم نتائج مصممة خصيصًا لاحتياجاتك ورؤيتك."
    },
    WhoWeServeCards: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "الشركات الناشئة",
            description:
                "بالنسبة للشركات الناشئة، كل خطوة مهمة. نحن نساعد الشركات في مراحلها الأولى من خلال تطوير تطبيقات فعالة من حيث التكلفة وقابلة للتطوير تجعل أفكارهم تنبض بالحياة. سواء كنت بحاجة إلى MVP لجذب المستثمرين أو منتج غني بالميزات لإطلاقه في السوق، فإننا نضمن أن حلولك تبرز وتنمو جنبًا إلى جنب مع عملك.",
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "شركات المنتجات البرمجية",
            description:
                "تدعم خبرتنا شركات المنتجات البرمجية في إنشاء حلول مبتكرة تركز على العملاء. من ترقية المنتجات الحالية إلى بناء تطبيقات جديدة من الصفر، نضمن أن برنامجك فعال وآمن ومصمم لتجاوز توقعات السوق. دعنا نتعامل مع التعقيدات التقنية بينما تركز أنت على النمو.",
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "المؤسسات من 30+ صناعة",
            description:
                "نحن شركاء مع الشركات في مختلف الصناعات، بما في ذلك الرعاية الصحية والتمويل والتعليم والخدمات اللوجستية، لتقديم حلول رقمية مخصصة. من خلال فهم التحديات الفريدة لكل صناعة، نقوم ببناء تطبيقات تدفع الكفاءة، وتعزز مشاركة العملاء، وتقدم تأثيرًا تجاريًا قابلاً للقياس.",
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const WhyChooseBitsclanDataArabic = {
    WhyChooseBitsclanContent: {
        mainHeading: "لماذا تختار بيتسكلان كشركة لتطوير تطبيقات الويب الخاصة بك؟",
        sectionDescription: "في بيتسكلان، نعيد تعريف معنى بناء تطبيقات الويب القوية والقابلة للتطوير. تكمن خبرتنا في صياغة حلول تطبيقات الويب المخصصة التي تتماشى بسلاسة مع أهداف عملك. سواء كان الأمر يتعلق بتصميم تطبيقات ويب حديثة من الصفر أو ترقية الأنظمة القديمة، فإننا نضمن نجاحك في كل خطوة."
    },
    WhyChooseBitsclanTabs: [
        {
            id: "Tab1",
            label: "الجودة لأنها تهم",
            content:
                "نحن نعطي الأولوية للجودة في كل سطر من التعليمات البرمجية التي نكتبها. مع التركيز على تجربة المستخدم والوظائف والأداء، يقدم مطورو تطبيقات الويب لدينا حلولًا آمنة وقوية وجاهزة للمستقبل. يتم اختبار كل تطبيق بدقة لتلبية أعلى معايير الصناعة.",
            btnText: "تواصل مع القبيلة",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "أفضل المواهب من الطراز الأول",
            content:
                "يتكون فريقنا من مطوري تطبيقات الويب من مبتكرين يتفوقون في أحدث الأطر والتقنيات. مع خبرة واسعة في بناء تطبيقات الويب المخصصة، نجمع بين الإبداع والخبرة التقنية لإنشاء حلول تطبيقات ويب متميزة.",
            btnText: "تواصل مع القبيلة",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "محاذاة المنطقة الزمنية",
            content:
                "العمل في مناطق زمنية مختلفة أصبح شيئًا من الماضي. يتوافق فريقنا مع المناطق الزمنية القريبة لضمان التواصل السلس والتعاون السلس وتسليم المشروع في الوقت المناسب. وهذا يضمن عدم وجود فجوات في الفهم أو التنفيذ.",
            btnText: "تواصل مع القبيلة",
            btnLink: "#",
        },
    ]
}

export const WebServicesHighvaluesDataArabic = {
    webDevHighValueContent: {
        mainHeading: "ميزات عالية القيمة لتطبيقات عالية الأداء",
        sectionDescription: "تقديم تطبيقات ويب استثنائية يدور حول الجمع بين الابتكار والخبرة والوظائف. في Bitsclan، نضمن أن يتضمن تطبيق الويب الخاص بك الميزات التي تدفع الأداء ومشاركة المستخدم وقابلية التوسع.",
        sectionButtonText: "استشر نطاق المشروع"
    },
    webDevHighValueCards: [
        {
            image: "custom-app-development.svg",
            text: "تطوير التطبيقات المخصصة",
        },
        {
            image: "user-centric-designs.svg",
            text: "تصاميم تركز على المستخدم",
        },
        {
            image: "robust-architecture.svg",
            text: "بنية قوية",
        },
        {
            image: "efficient-integration.svg",
            text: "تكامل فعال",
        },
        {
            image: "advanced-analytics.svg",
            text: "تحليلات متقدمة",
        },
        {
            image: "enhanced-security.svg",
            text: "أمان معزز",
        },
        {
            image: "agile-methodology.svg",
            text: "منهجية رشيقة",
        },
        {
            image: "cross-platform-support.svg",
            text: "دعم عبر المنصات",
        },
        {
            image: "ongoing-maintenance.svg",
            text: "صيانة مستمرة",
        },
        {
            image: "innovation-driven-features.svg",
            text: "ميزات مدفوعة بالابتكار",
        },
    ]
}

export const webDevPageIndustriesSectionArabic = {
    mainHeading: "الصناعات التي نخدمها في تطوير تطبيقات الويب"
}

export const WebServicesFaqDataArabic = {
    wePageFaqContent: {
        mainHeading: "الأسئلة الشائعة",
        sectionDescription: "احصل على إجابات سريعة لأسئلتك حول عملية وخدمات تطوير تطبيقات الهاتف المحمول لدينا."
    },
    webServiceQuestionAnswer: [
        {
            id: "collapseOne",
            question: "ما هي تكلفة بناء تطبيق ويب؟",
            answer:
                "يعتمد سعر تطوير تطبيق الويب على مدى تعقيده، والجدول الزمني للمشروع، وعوامل أخرى مثل هذه. لمساعدتك على الفهم، يمكن إنشاء تطبيق بسيط بمبلغ 1,500 دولار. من ناحية أخرى، يمكن أن يكلف تطوير تطبيق ويب متقدم بميزات الذكاء الاصطناعي ما يصل إلى 50,000 دولار.",
        },
        {
            id: "collapseTwo",
            question: "ما أنواع تطبيقات الويب التي يمكنك إنشاؤها؟",
            answer:
                "نحن متخصصون في تطوير مجموعة واسعة من تطبيقات الويب، بما في ذلك حلول المؤسسات، ومنصات التجارة الإلكترونية، وبوابات العملاء، وأنظمة إدارة سلسلة التوريد، وأنظمة CRM/ERP، والمزيد. تسمح لنا خبرتنا بتخصيص التطبيقات لتلبية الاحتياجات المحددة لمختلف الصناعات.",
        },
        {
            id: "collapseThree",
            question: "كيف يعمل تطبيق الويب التقدمي؟",
            answer:
                "تجمع تطبيقات الويب التقدمية (PWAs) أفضل ما في تطبيقات الويب والهاتف المحمول. تعمل هذه التطبيقات من خلال الاستفادة من إمكانيات الويب الحديثة لتقديم تجربة تشبه التطبيق في المتصفح، بما في ذلك الوصول دون اتصال بالإنترنت، والإشعارات الفورية، وأوقات تحميل أسرع، كل ذلك دون الحاجة إلى التنزيل من متجر التطبيقات.",
        },
        {
            id: "fourth",
            question: "ما هو الجدول الزمني النموذجي لبناء تطبيق ويب؟",
            answer:
                "يختلف الجدول الزمني لتطوير تطبيق الويب بناءً على تعقيده، وميزاته، ونطاقه. في المتوسط، قد يستغرق تطبيق الويب الأساسي من 3 إلى 6 أشهر، بينما يمكن أن تستغرق التطبيقات الأكثر تعقيدًا من 6 إلى 12 شهرًا أو أكثر، من الاكتشاف الأولي إلى النشر النهائي.",
        },
        {
            id: "fifth",
            question: "كيف تحمي أمان تطبيقات الويب؟",
            answer:
                "نعطي الأولوية للأمان طوال عملية التطوير من خلال تطبيق أفضل الممارسات مثل التشفير، والمصادقة الآمنة، وعمليات تدقيق الأمان المنتظمة. كما أننا نلتزم بإرشادات OWASP ونضمن الامتثال للمعايير الصناعية ذات الصلة لحماية تطبيق الويب الخاص بك من التهديدات المحتملة.",
        },
        {
            id: "sixth",
            question:
                "ما الذي يجب أن أضعه في الاعتبار عند اختيار شركة لتطوير تطبيقات الويب؟",
            answer:
                "عند اختيار شريك لتطوير تطبيقات الويب، ابحث عن شركة ذات محفظة قوية، وخبرة مثبتة في مجال عملك، وتواصل شفاف، وفهم واضح لأهداف عملك. من الضروري أيضًا التأكد من أنهم يتبعون أفضل الممارسات للأمان وقابلية التوسع والأداء.",
        },
        {
            id: "seventh",
            question:
                "كيف يختلف تطوير تطبيقات الويب عن تطوير مواقع الويب؟",
            answer:
                "يركز تطوير تطبيقات الويب على إنشاء أنظمة تفاعلية وديناميكية تؤدي مهامًا معقدة، مثل إدارة المستخدمين، ومعالجة البيانات، والتفاعل في الوقت الفعلي. في المقابل، يتضمن تطوير مواقع الويب عادةً إنشاء مواقع ثابتة أو تعتمد على المحتوى تعرض المعلومات وقد تحتوي على ميزات تفاعلية محدودة.",
        },
    ]
}

export const CoverTheStackArabic = {
    CoverTheStackContent: {
        mainHeading: "بناء تطبيقات ويب قابلة للتطوير وعالية الأداء مع مطورين خبراء",
        sectionDescription: "في Bitsclan، نمكّن رحلة تطوير تطبيقات الويب الخاصة بك من خلال مجموعة تقنية متطورة تضمن الأداء السلس وقابلية التوسع والابتكار. يتخصص مطورونا الخبراء في صياغة تطبيقات ويب مخصصة مصممة خصيصًا لاحتياجات عملك، وتقديم تجارب مستخدم استثنائية ووظائف قوية.",
        defaultTabOpen: "الواجهة الأمامية"
    },

    tabs: [
        "الواجهة الأمامية",
        "الواجهة الخلفية",
        "المكتبات",
        "قاعدة البيانات",
    ],

    tabItems: [
        { tab: "الواجهة الأمامية", icon: "/images/iconthree.png", name: "React JS" },
        { tab: "الواجهة الأمامية", icon: "/images/iconone.png", name: "Angular JS" },
        { tab: "الواجهة الأمامية", icon: "/images/icon7.png", name: "HTML5" },
        { tab: "الواجهة الأمامية", icon: "/images/icon6.png", name: "CSS3" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/gatsby.svg", name: "Gatsby" },
        { tab: "الواجهة الأمامية", icon: "/images/icon4.png", name: "Vue JS" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/ember.svg", name: "Ember.js" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/svelte.svg", name: "Svelte" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/backbone-js.svg", name: "Backbone.js" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/polymer.svg", name: "Polymer" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/aurelia.svg", name: "Aurelia" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/meteor.svg", name: "Meteor.js" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/next-js.svg", name: "Next.js" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/semantic.svg", name: "Semantic-UI" },
        { tab: "الواجهة الأمامية", icon: "/images/tech-stack-icons/nuxt-js.svg", name: "Nuxt" },
        { tab: "الواجهة الخلفية", icon: "/images/database9.png", name: "Node Js" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/elixir.svg", name: "Elixir" },
        { tab: "الواجهة الخلفية", icon: "/images/database1.png", name: ".Net" },
        { tab: "الواجهة الخلفية", icon: "/images/database6.png", name: "Python" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/ruby_on_rails.svg", name: "Ruby On Rails" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/java.svg", name: "Java" },
        { tab: "الواجهة الخلفية", icon: "/images/database8.png", name: "PHP" },
        { tab: "الواجهة الخلفية", icon: "/images/django-tech.svg", name: "Django" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/golang.svg", name: "Go" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/c-sharp.svg", name: "C#" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/scala.svg", name: "Scala" },
        { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/rust.svg", name: "Rust" },
        { tab: "قاعدة البيانات", icon: "/images/db5.png", name: "MySQL" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/couchdb.svg", name: "Couch DB" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/indexed.svg", name: "Indexed DB" },
        { tab: "قاعدة البيانات", icon: "/images/db3.png", name: "MongoDB" },
        { tab: "قاعدة البيانات", icon: "/images/db7.png", name: "SQLite" },
        { tab: "قاعدة البيانات", icon: "/images/db6.png", name: "MS SQL Server" },
        { tab: "قاعدة البيانات", icon: "/images/db1.png", name: "Firebase" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/swift.svg", name: "Swift" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/redis.svg", name: "Redis" },
        { tab: "قاعدة البيانات", icon: "/images/db8.png", name: "DynamoDB" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/jquery.svg", name: "jQuery" },
        { tab: "المكتبات", icon: "/images/iconthree.png", name: "React" },
        { tab: "المكتبات", icon: "/images/iconone.png", name: "Angular" },
        { tab: "المكتبات", icon: "/images/icon4.png", name: "Vue.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/vue-x.svg", name: "Vue.x" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/rx-js.svg", name: "Rxjs" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/bootstrap.svg", name: "Bootstrap" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/backbone-js.svg", name: "Backbone.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/ember.svg", name: "Ember.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/d3-js.svg", name: "D3.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/redux.svg", name: "Redux" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/lodash.svg", name: "Lodash" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/styled-component.svg", name: "Styled Component" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/emotion.svg", name: "Emotion" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/graphql.svg", name: "Graph QL" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/ant-design.svg", name: "Ant Design" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/inertia.svg", name: "Inertia.js" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/mobx.svg", name: "Mobx" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/web3.svg", name: "Web3" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/Web.svg", name: "WebGL" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/core-ui.svg", name: "Core UI" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/tailwind.svg", name: "Tailwind" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/material-ui.svg", name: "Material UI" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/flow-js.svg", name: "Flow.js" },
    ]
}

export const WebAppservicesRoadMapArabic = {
    RoadMapContent: {
        mainHeading: "خارطة طريقنا المثبتة لضمان نجاحك",
        sectionDescription: "بصفتنا شريكًا موثوقًا لتطوير تطبيقات الويب، فقد قمنا بصياغة خارطة طريق منظمة لضمان نجاح مشروعك. من الاكتشاف إلى النشر، نقوم بمواءمة كل مرحلة مع أهداف عملك، وتقديم تطبيقات ويب قابلة للتطوير، وتطبيقات ويب حديثة، وحلول تطبيقات ويب مخصصة. إليك كيفية قيامنا بذلك:"
    },

    RoadMapHeading: [
        "الاكتشاف والتخطيط",
        "التصميم وإثبات المفهوم",
        "التطوير والاختبار",
        "التنفيذ والدعم"
    ],
    RoadMapDescription: [
        "كل تطبيق ويب رائع يبدأ بأساس متين. في هذه المرحلة، نعمل معك عن كثب لفهم أهدافك، وتحديد النطاق، وإنشاء خطة استراتيجية. يضمن مطورو تطبيقات الويب لدينا أن تطبيقات الويب المخصصة الخاصة بك مصممة لتتوافق بسلاسة مع رؤيتك واحتياجات السوق.",
        "نحن نحول أفكارك إلى حقيقة بتصاميم بديهية وإثبات مفهوم قوي. تتحقق هذه الخطوة من الجدوى وتضمن قابلية توسع تطبيقات الويب الخاصة بك، مع التركيز على تجارب المستخدم التي تركز على المستخدم والحلول الجاهزة للمستقبل.",
        "باستخدام الأطر الحديثة، يطور فريقنا الخبير تطبيقات ويب عالية الأداء محسّنة للسرعة والأمان والوظائف. يضمن الاختبار الصارم أن تطبيقات الويب المخصصة الخاصة بك خالية من الأخطاء وجاهزة للأداء في ظروف العالم الحقيقي.",
        "نحن لا نكتفي بالتسليم - نحن نضمن نجاح تطبيقك. من النشر السلس إلى الدعم المستمر، نساعدك على تحسين تطبيقات الويب القابلة للتطوير بمرور الوقت، والتكيف مع احتياجات العمل المتطورة والحفاظ على حلولك في طليعة التطور.",
    ]
}